export default __webpack_public_path__ + "static/media/Estado01.f08e49aa.gif";